import AcademicYearCurriculumProgramsMapTypePolicy from "./AcademicYearCurriculumProgramsMap";
import ACLFeatureFlagTypePolicy from "./ACLFeatureFlag";
import AdmissionTypePolicy from "./Admission";
import ACLPermissionTypePolicy from "./ACLPermission";
import ACLPermissionsResponseTypePolicy from "./ACLPermissionsResponse";
import ACLPreferenceTypePolicy from "./ACLPreference";
import ConfigurationV2TypePolicy from "./ConfigurationV2";
import CourseTypePolicy from "./Course";
import OrganizationTypePolicy from "./Organization";
import PlannerATLTypePolicy from "./PlannerATL";
import PlannerBenchmarkTypePolicy from "./PlannerBenchmark";
import PlannerTypePolicy from "./Planner";
import PlatformQueryTypePolicy from "./Platform";
import ProjectGroupTypePolicy from "./ProjectGroup";
import RnPRoleTypePolicy from "./RnPRole";
import StandardBenchmarkTypePolicy from "./StandardBenchmark";
import StudentTypePolicy from "./Student";
import SubjectTypePolicy from "./Subject";
import YearGroupTypePolicy from "./YearGroup";
import ACLGlobalTemplateTypePolicy from "./ACLGlobalTemplate";
import ACLGlobalRoleTypePolicy from "./ACLGlobalRole";
import ACLGlobalControlParameterTypePolicy from "./ACLGlobalControlParameter";
import ReleaseItemTypePolicy from "./ReleaseItem";
import GradingCommentTemplateTypePolicy from "./GradingCommentTemplate";
import IbMypCurriculumProgramPolicy from "./IbMypCurriculumProgramPolicy";
import IbPypCurriculumProgramPolicy from "./IbPypCurriculumProgramPolicy";
import UBDCurriculumProgramPolicy from "./UBDCurriculumProgramPolicy";
import IbDpCurriculumProgramPolicy from "./IbDpCurriculumProgramPolicy";
import GenericCurriculumProgramPolicy from "./GenericCurriculumProgramPolicy";
import BehaviourIncidentTypePolicy from "./BehaviourIncident";
import GradeScaleTypePolicy from "./GradeScaleTypePolicy";
import MultiPlatformCategorizedValuesTypePolicy from "./MultiPlatformCategorizedValues";
import LearningGoalRatingTypePolicy from "./LearningGoalRatingTypePolicy";
import SettingsPortalCustomTagsTypePolicy from "./SettingsPortalCustomTags";
import LearningCoursePolicy from "./LearningCoursePolicy";
import TranscriptBulkUploadTransactionTypePolicy from "./TranscriptBulkUploadTransaction";
import TranscriptV3BulkUploadTransactionTypePolicy from "./TranscriptV3BulkUploadTransaction";
import CurriculumInsightsPolicy from "./CurriculumInsightsPolicy";
import LearningCourseSyncHistoryPolicy from "./LearningCourseSyncHistoryPolicy";
import CurriculumWebsiteNodePolicy from "./CurriculumWebsiteNodePolicy";
import UIElementCardTypePolicy from "./UIElementCardTypePolicy";
import StudentProgressReportReflectionTypePolicy from "./StudentProgressReportReflection";
import StudentProgressReportPypElementRatingTypePolicy from "./StudentProgressReportPypElementRating";
import CurriculumMapsPolicy from "./CurriculumMapsPolicy";
import ElasticacheInternalToolQueryTypePolicy from "./ElasticacheInternalToolQuery";

export const typePolicies = {
  ...AcademicYearCurriculumProgramsMapTypePolicy,
  ...ACLFeatureFlagTypePolicy,
  ...AdmissionTypePolicy,
  ...ACLPermissionTypePolicy,
  ...ACLPermissionsResponseTypePolicy,
  ...ACLPreferenceTypePolicy,
  ...ConfigurationV2TypePolicy,
  ...CourseTypePolicy,
  ...OrganizationTypePolicy,
  ...PlannerATLTypePolicy,
  ...PlannerBenchmarkTypePolicy,
  ...PlannerTypePolicy,
  ...PlatformQueryTypePolicy,
  ...ProjectGroupTypePolicy,
  ...RnPRoleTypePolicy,
  ...StandardBenchmarkTypePolicy,
  ...StudentTypePolicy,
  ...SubjectTypePolicy,
  ...YearGroupTypePolicy,
  ...ACLGlobalTemplateTypePolicy,
  ...ACLGlobalRoleTypePolicy,
  ...ACLGlobalControlParameterTypePolicy,
  ...ReleaseItemTypePolicy,
  ...GradingCommentTemplateTypePolicy,
  ...IbMypCurriculumProgramPolicy,
  ...IbPypCurriculumProgramPolicy,
  ...UBDCurriculumProgramPolicy,
  ...IbDpCurriculumProgramPolicy,
  ...GenericCurriculumProgramPolicy,
  ...BehaviourIncidentTypePolicy,
  ...GradeScaleTypePolicy,
  ...MultiPlatformCategorizedValuesTypePolicy,
  ...LearningGoalRatingTypePolicy,
  ...SettingsPortalCustomTagsTypePolicy,
  ...LearningCoursePolicy,
  ...TranscriptBulkUploadTransactionTypePolicy,
  ...TranscriptV3BulkUploadTransactionTypePolicy,
  ...CurriculumInsightsPolicy,
  ...LearningCourseSyncHistoryPolicy,
  ...CurriculumWebsiteNodePolicy,
  ...UIElementCardTypePolicy,
  ...StudentProgressReportReflectionTypePolicy,
  ...StudentProgressReportPypElementRatingTypePolicy,
  ...CurriculumMapsPolicy,
  ...ElasticacheInternalToolQueryTypePolicy,
};

export default typePolicies;
